import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DialogConfig } from '../dialog/dialog-config';
import { PopUIEngineComponent } from '../pop-uiengine/pop-uiengine.component';

@Component({
    selector: 'app-audit-log',
    templateUrl: '../ui-engine/ui-engine.component.html',
    styleUrls: ['../ui-engine/ui-engine.component.scss'],
    standalone: false
})
export class AuditLogComponent extends PopUIEngineComponent implements OnInit {

  constructor(public injector: Injector, public smartModal: BsModalService, public router: Router, public route: ActivatedRoute, public dialogConfig: DialogConfig) {
    super(injector, smartModal,router,route,dialogConfig);
  }
  ngOnInit() {
    this.filterData = {};
    this.filterData.resource_filter = this.dialogConfig.data.resource_filter;
    super.ngOnInit();
  }

  // initLayoutData(action?){
  //   this._layout_data.config.configure_grid = false;
  //   this._layout_data.config.help = false;
  //   this._layout_data.list.filter.blocks[0].fields.splice(0, 2);
  //   this._layout_data.list.filter.blocks[0].fields.push({
  //     "name": "resource_name",
  //     "component": "hidden",
  //     "default": this.filterData.resource_filter
  //   })
  //   super.initLayoutData(action);
  // }

  getFilter() {
    this._currentData.gridData['filter'] = 'resource_name:'+this.filterData.resource_filter;
  }
  
}
